import ENUM from '../ENUM'

export default {
    kind: 'QuestionSlide',
    filters: [],
    references: [ENUM().pageQuestionId],
}
